import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  Form,
  Card,
  Select,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const CreateAuctionAllotment = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams(); // auctionId

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const payload = {
        auctionId: Number(id),
        portfolioId: values.portfolioId,
        allottedAmount: values.allottedAmount,
        allottedPrice: values.allottedPrice,
        allottedYield: values.allottedYield,
      };

      // await BOM.SendReq(apiConfig.createAuctionAllotment, payload);
      console.log("CreateAuctionAllotment payload:", payload);
      BOM.AlertMsg(cnt.SUCCESS, "Auction allotment created successfully.");
      navigate(-1);
    } catch (error) {
      BOM.AlertMsg(cnt.DANGER, error?.message || "Failed to create auction allotment.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout pageItems={staticConfig.newAuction}>
      <TopContent pageTitle={labelConfig.securityProduct} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <h3 style={{ marginBottom: 24, fontWeight: 600 }}>
              Create Auction Allotment
            </h3>

            <Form layout="vertical" form={form} onFinish={onFinish}>

              {/* Portfolio & Allotted Amount */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Portfolio
                        <Tooltip title="The portfolio to which this allotment is assigned.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="portfolioId"
                    rules={[{ required: true, message: "Portfolio is required" }]}
                  >
                    <Select
                      style={{ height: 44 }}
                      suffixIcon={<ChevronDown color="#667085" />}
                      options={portfolioOptions}
                      placeholder="Select Portfolio"
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Allotted Amount
                        <Tooltip title="The face value amount allotted to this portfolio.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="allottedAmount"
                    rules={[
                      { required: true, message: "Allotted amount is required" },
                      { type: "number", min: 1, message: "Amount must be greater than 0" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 50,000,000.00"
                      formatter={(value) =>
                        value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                      }
                      parser={(value) => value?.replace(/,/g, "")}
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Allotted Price & Allotted Yield */}
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Allotted Price
                        <Tooltip title="The price per 100 face value at which allotment is made.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="allottedPrice"
                    rules={[
                      { required: true, message: "Allotted price is required" },
                      { type: "number", min: 0, max: 100, message: "Price must be between 0 and 100" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 98.50"
                      precision={2}
                      min={0}
                      max={100}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Allotted Yield (%)
                        <Tooltip title="The annualised yield rate at which allotment is made.">
                          <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
                        </Tooltip>
                      </span>
                    }
                    name="allottedYield"
                    rules={[
                      { required: true, message: "Allotted yield is required" },
                      { type: "number", min: 0, message: "Yield must be 0 or greater" },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%", height: 44 }}
                      placeholder="e.g. 12.50"
                      precision={2}
                      min={0}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Divider */}
              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              {/* Action Buttons */}
              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #BA24D5",
                      background: "#BA24D5",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Submit
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, { rightAction })(CreateAuctionAllotment);